import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/views/Home'
import FengyouIntro from '@/views/FengyouIntro'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'Home',
      component: Home
    },
    {
      path: '/fengyou',
      name: 'FengyouIntro',
      component: FengyouIntro
    }
  ]
})